import { useEffect, useRef } from 'react';
import { Quill } from 'seagull/patches/PatchedQuill';
export function useQuillKeyboardTrigger(editorElRef, openPicker, handleInsertVariable, enabled) {
  const anchorSpanRef = useRef(null);
  const parentPositionRef = useRef(null);
  useEffect(() => {
    if (!enabled) return;
    const editorEl = editorElRef.current;
    if (!editorEl) return;
    const handleKeyDown = event => {
      if (event.key !== '{') return;
      const quill = Quill.find(editorEl);
      if (!quill) return;
      const range = quill.getSelection();
      if (!range) return;
      const cursorIndex = range.index;
      if (cursorIndex < 1) return;
      const charBefore = quill.getText(cursorIndex - 1, 1);
      if (charBefore !== '{') return;
      event.preventDefault();
      quill.deleteText(cursorIndex - 1, 1, 'user');
      const savedIndex = cursorIndex - 1;
      const restoreDeletedBraces = () => {
        quill.insertText(savedIndex, '{{', 'user');
        quill.setSelection(savedIndex + 2, 0, 'silent');
      };
      const bounds = quill.getBounds(savedIndex);
      if (!bounds) {
        restoreDeletedBraces();
        return;
      }
      cleanupAnchor(anchorSpanRef, parentPositionRef);
      const editorParent = editorEl.parentElement;
      if (!editorParent) {
        restoreDeletedBraces();
        return;
      }
      const anchor = document.createElement('span');
      anchor.style.position = 'absolute';
      anchor.style.left = "".concat(bounds.left, "px");
      anchor.style.top = "".concat(bounds.top, "px");
      anchor.style.width = '0';
      anchor.style.height = "".concat(bounds.height, "px");
      anchor.style.pointerEvents = 'none';
      const originalPosition = editorParent.style.position;
      parentPositionRef.current = {
        parent: editorParent,
        original: originalPosition
      };
      editorParent.style.position = originalPosition || 'relative';
      editorParent.appendChild(anchor);
      anchorSpanRef.current = anchor;
      openPicker(anchor, label => {
        handleInsertVariable(label);
        cleanupAnchor(anchorSpanRef, parentPositionRef);
      }, () => {
        var _editorElRef$current;
        const q = Quill.find((_editorElRef$current = editorElRef.current) !== null && _editorElRef$current !== void 0 ? _editorElRef$current : editorEl);
        if (q) {
          q.insertText(savedIndex, '{{', 'user');
          q.setSelection(savedIndex + 2, 0, 'silent');
        }
        cleanupAnchor(anchorSpanRef, parentPositionRef);
      });
    };
    editorEl.addEventListener('keydown', handleKeyDown);
    return () => {
      editorEl.removeEventListener('keydown', handleKeyDown);
      cleanupAnchor(anchorSpanRef, parentPositionRef);
    };
  }, [editorElRef, openPicker, handleInsertVariable, enabled]);
}
function cleanupAnchor(anchorSpanRef, parentPositionRef) {
  if (anchorSpanRef.current) {
    anchorSpanRef.current.remove();
    anchorSpanRef.current = null;
  }
  if (parentPositionRef.current) {
    parentPositionRef.current.parent.style.position = parentPositionRef.current.original;
    parentPositionRef.current = null;
  }
}